// src/pages/sow-template/UploadTemplateModal.jsx
import PropTypes from "prop-types";
import { Button, FormField, Input, Modal, Select } from "../../shared/ui";

export default function UploadTemplateModal({
  open,
  onClose,
  name,
  onNameChange,
  version,
  onVersionChange,
  contractType,
  onContractTypeChange,
  file,
  onFileChange,
  onUpload,
  busy,
  scope,
  onScopeChange,
  scopeOptions,
  scopeAccountId,
  onScopeAccountIdChange,
  accountOptions,
}) {
  return (
    <Modal
      open={open}
      title="Upload Template DOCX"
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button onClick={onUpload} disabled={busy || !file} loading={busy}>
            Upload & Parse
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <FormField label="Template Name" required>
          <Input value={name} onChange={(e) => onNameChange(e.target.value)} placeholder="e.g. Standard T&M SOW" />
        </FormField>
        <div className="grid grid-cols-2 gap-3">
          <FormField label="Version">
            <Input value={version} onChange={(e) => onVersionChange(e.target.value)} placeholder="1.0" />
          </FormField>
          <FormField label="Contract Type" helperText="Optional">
            <Input value={contractType} onChange={(e) => onContractTypeChange(e.target.value)} placeholder="e.g. T&M" />
          </FormField>
        </div>
        <FormField label="DOCX File" required>
          <input
            type="file"
            accept=".docx"
            onChange={(e) => onFileChange(e.target.files?.[0] || null)}
            className="text-sm"
          />
        </FormField>
        <FormField label="Visibility">
          <Select options={scopeOptions} value={scope} onChange={(e) => onScopeChange(e.target.value)} />
        </FormField>
        {scope === "account" && (
          <FormField label="Account" required>
            <Select
              options={[{ value: "", label: "Choose an account…" }, ...accountOptions]}
              value={scopeAccountId}
              onChange={(e) => onScopeAccountIdChange(e.target.value)}
            />
          </FormField>
        )}
      </div>
    </Modal>
  );
}

UploadTemplateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onNameChange: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
  onVersionChange: PropTypes.func.isRequired,
  contractType: PropTypes.string.isRequired,
  onContractTypeChange: PropTypes.func.isRequired,
  file: PropTypes.object,
  onFileChange: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  scope: PropTypes.string.isRequired,
  onScopeChange: PropTypes.func.isRequired,
  scopeOptions: PropTypes.array.isRequired,
  scopeAccountId: PropTypes.string.isRequired,
  onScopeAccountIdChange: PropTypes.func.isRequired,
  accountOptions: PropTypes.array.isRequired,
};
